import {Types}  from "../actions/paymentActions";
import _ from "lodash";


const defaultState = {
};

// TRACKING_CATEGORIES
// ACCOUNT_CODES
// CONNECTED_TO_XERO

const reducer = (state = defaultState, action) => {
  switch (action.type) {


    case Types.PURCHASE_SERVICE: {

      const newState = {...state};

      const currentServices = newState?.payment?.services ?? []
      console.log('currentServices',currentServices)
      newState.payment.services = [...currentServices,action.payload.purchasedService]

      return newState;
    }



    case Types.PURCHASED_SERVICES: {

      const newState = {...state};

      newState.payment.services = Array.isArray(action.payload) ? action.payload : []

      return newState;
    }



    case Types.PAYMENT_STRIPE_ADD_NEW_CARD: {

      const newState = {...state};

      newState.payment.stripe.addNewCard = action.status

      return newState;
    }


    case Types.PAYMENT_STRIPE_SAVING_CARD: {

      const newState = {...state};

      newState.payment.stripe.savingCard = action.status
      if (!action.status){
        // if saved card then no need to show the new card UI right?
        newState.payment.stripe.addNewCard = false
      }
      
      return newState;
    }


    case Types.STRIPE_PROCESSING_CHARGE: {

      const newState = {...state};

      newState.payment.stripe.processingCharge = true
      newState.payment.stripe.paymentIntent = null
      
      return newState;
    }

    case Types.STRIPE_CREATE_CHARGE: {

      const newState = {...state};

      newState.payment.stripe.processingCharge = false

      if (action.payload.invoiceNo){
        newState.payment.invoiceNo = action.payload.invoiceNo;
      }

      if (action.payload.paymentIntent == "success"){
        newState.payment.modal = false
      } else{
        newState.payment.stripe.paymentIntent = action.payload.paymentIntent
      }

      console.log('actionCREATECHARTE',action)
      // newState.payment.selectedBundle = action.bundle
      
      return newState;
    }
    case Types.PAYMENT_SELECT_BUNDLE: {

      const newState = {...state};

      newState.payment.selectedBundle = action.bundle
      
      return newState;
    }
    case Types.PAYMENT_MODAL: {

      const newState = {...state};

      newState.payment.modal = action.status
      
      return newState;
    }

    case Types.PAYMENT_GET_STATS: {

      const newState = {...state};

      newState.payment.stats = action.payload
      
      return newState;
    }
    case Types.PAYMENT_GET_BUNDLES: {

      const newState = {...state};

      newState.payment.bundles = action.payload
      
      return newState;
    }

    case Types.STRIPE_LIST: {

      const newState = {...state};

      newState.payment.stripe.list = action.payload
      
      return newState;
    }

    case Types.STRIPE_CREATE_CUSTOMER: {

      const newState = {...state};

      console.log('action.payload',action.payload)

      if (!newState.payment.stats){
        newState.payment.stats = {}
      }

      newState.payment.stats.stripeCustomerID = action.payload.id
      
      return newState;
    }

    case Types.STRIPE_INTENT: {

      const newState = {...state};

      newState.payment.stripe.intent = action.payload
      
      return newState;
    }
    case Types.STRIPE_PAYMENT_METHODS: {

      const newState = {...state};

      newState.payment.stripe.paymentMethods = action.payload

      if(action.payload.length > 0){
        newState.payment.stripe.addNewCard = false
      }
      
      return newState;
    }
    case Types.PURCHASE_SERVICE: {
      const newState = {...state};
      return newState;
    }
    case Types.PURCHASED_SERVICES: {
      const newState = {...state};

      return newState;
    }
    case Types.PURCHASE_CONFIRMATION_MODAL_OPEN: {
      const newState = {...state};
      newState.payment.selectedServiceId = action.selectedServiceId;
      newState.payment.purchaseConfirmationModalOpen = action.modalOpen; 
      return newState;
    }

    default:
      return state;
  }
};

export default reducer;